<template>
  <section class="naming-logos">
    <h2 class="text-h6">Logo Logic</h2>
    <v-row>
      <v-col col="12">
        <div class="parent-logo">
          <div class="circle" :style="{ borderColor: getColor(0) }"></div>

          <h1 class="text-center">{{ attrs.brand }}</h1>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(item, index) in doc.list"
        :key="`logo-${item.name}-${id}`"
        :cols="getCols"
        class="text-center"
      >
        <div class="parent-logo">
          <div v-if="item.logo">
            <v-chip v-if="item.logo" color="amber" class="mb-4" light
              >Logo</v-chip
            >
          </div>

          <div
            v-else
            class="circle"
            :style="{ borderColor: getColor(index) }"
          ></div>
          <h1 class="text-center">{{ item.title }}</h1>
        </div>
        <v-row>
          <v-col
            v-for="child in item.children"
            :key="`child-${child.name}-${id}`"
            cols="4"
          >
            <div class="naming-logo">
              <div v-if="child.logo">
                <v-chip v-if="child.logo" color="amber" class="mb-4" light
                  >Logo</v-chip
                >
              </div>
              <div
                v-else
                class="circle"
                :style="{ borderColor: getColor(index) }"
              ></div>
              <h2 class="">{{ getName(child) }}</h2>
              <p v-if="!child.logo" class="">{{ attrs.brand }}</p>
            </div>

            <div
              v-for="sub in child.children"
              :key="`sub-${sub.name}-${id}`"
              class=""
            >
              <div class="location-logo">
                <h2 class="">
                  {{ getName(sub) }}<span v-if="sub.logo"> *</span>
                </h2>

                <div v-if="sub.logo">
                  <v-chip v-if="child.logo" color="amber" class="mb-4" light
                    >Logo</v-chip
                  >
                </div>
                <p v-else-if="!child.logo" class="">
                  {{ attrs.brand }}
                </p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: "NamingLogos",
  data() {
    return {};
  },
  props: {
    cols: {
      type: Number,
      default: 4,
    },
    id: {
      type: String,
      default: "diushoaidcs",
    },
    doc: {
      type: Object,
      default: () => ({}),
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  computed: {
    getCols() {
      if (this.doc.listNames) {
        const l = this.doc.listNames.length;
        switch (l) {
          case 1:
            return 12;
          case 2:
            return 6;
          case 3:
            return 4;
          case 4:
            return 3;
          default:
            return 4;
        }
      } else {
        return 12;
      }
    },
  },
  methods: {
    getColor(col) {
      switch (col) {
        case 0:
          return "#009688";
        case 1:
          return "#F44336";
        case 2:
          return "#673AB7";
        case 3:
          return "#1B5E20";
        case 4:
          return "#2196F3";
        default:
          return "#E91E63";
      }
    },
    getName(el) {
      if (this.doc.prefix && el.allowPrefix) {
        switch (this.doc.prefixPosition) {
          case "after":
            return `${el.name}${this.doc.prefix}`;
          case "after-space":
            return `${el.name} ${this.doc.prefix}`;
          case "before":
            return `${this.doc.prefix}${el.name}`;
          case "before-space":
            return `${this.doc.prefix} ${el.name}`;
        }
      } else {
        return el.name;
      }
    },
  },
};
</script>

<style lang="scss"></style>
